/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { FaEnvelopeOpenText, FaReply, FaFileInvoiceDollar, FaGavel } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import '../All CSS/Home.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Home = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);
  const profileRef = useRef(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [counts, setCounts] = useState({
    enquiry: 0,
    responded: 0,
    po: 0,
    bids: 0
  });

  useEffect(() => {
    const userDetails = JSON.parse(sessionStorage.getItem('UserDetails'));
    if (!userDetails) {
      navigate('/');
    } else {
      setUser(userDetails);
    }
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isPopupOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isPopupOpen]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const togglePopup = () => setIsPopupOpen(prev => !prev);

  const fetchCounts = async () => {
    try {
      const userDetails = JSON.parse(sessionStorage.getItem('UserDetails'));
      const dbDetails = JSON.parse(sessionStorage.getItem('DatabaseDetails'));

      if (!userDetails || !dbDetails) throw new Error('Session expired - Please login again');

      const { BPCode: bpCode, CompCode: compcode } = userDetails;

      const response = await axios.post(`${API_BASE_URL}/api/vendorCounts`, {
        bpCode,
        compcode,
        dbDetails
      });

      const { data } = response.data;
      setCounts({
        enquiry: data.enquiry || 0,
        responded: data.responded || 0,
        po: data.po || 0,
        bids: data.bids || 0,
      });
    } catch (error) {
      console.error('Error fetching counts:', error.response?.data || error.message);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  const handleNavigation = (componentName) => {
    const Component = lazy(() =>
      import(`../Components/${componentName}.js`).catch(() => ({
        default: () => <h2>404 - Page Not Found</h2>
      }))
    );

    setSelectedComponent(
      <Suspense fallback={<div>Loading...</div>}>
        <Component onBack={() => setSelectedComponent(null)} refreshCounts={fetchCounts} />
      </Suspense>
    );
  };

  const menuItems = [
    {
      name: "Enquiry",
      icon: <FaEnvelopeOpenText size={40} />,
      count: counts.enquiry,
      component: "VendorPendingEnquiry",
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6, #1d4ed8)"
    },
    {
      name: "Responded",
      icon: <FaReply size={40} />,
      count: counts.responded,
      component: "VendorRespondedEnquiry",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981, #047857)"
    },
    {
      name: "PO",
      icon: <FaFileInvoiceDollar size={40} />,
      count: counts.po,
      component: "VendorPOList",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b, #d97706)"
    },
    {
      name: "BIDS",
      icon: <FaGavel size={40} />,
      count: counts.bids,
      component: "VendorOpenBIDList",
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444, #dc2626)"
    }
  ];


  return (
    <div className="Home-container">
      {/* Modern Navbar */}
      <nav className="modern-navbar">
        <div className="nav-brand">
          <div className="logo-container">
            <img
              src={require("../All images/logo-mini.png")}
              alt="Logo"
              className="brand-logo"
            />
          </div>
          <div className="brand-info" onClick={() => {
            setSelectedComponent(null);
            navigate("/home");
          }}
            style={{ cursor: "pointer" }}>
            <h1 className="Company-Name">{user?.CompName || 'Company Name'}</h1>
            <p className="company-subtitle">Vendor Portal</p>
          </div>
        </div>

        <div className="nav-user-section">
          <div className="user-info">
            <span className="user-welcome">Welcome,</span>
            <span className="user-name">{user?.EMailID || 'EmailID'}</span>
          </div>
          <div className="profile-container" ref={profileRef}>
            <button className="profile-btn" onClick={togglePopup}>
              <img
                src="https://cdn-icons-png.freepik.com/256/17740/17740782.png"
                alt="Profile"
                className="profile-avatar"
              />
              <span className="profile-arrow">▼</span>
            </button>

            {isPopupOpen && (
              <div className="profile-dropdown" ref={popupRef}>
                <div className="dropdown-header">
                  <h3>Profile Information</h3>
                </div>
                <div className="dropdown-content">
                  <div className="info-item">
                    <span className="info-label">Name:</span>
                    <span className="info-value">{user?.BPName}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{user?.EMailID}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Contact Person:</span>
                    <span className="info-value">{user?.ContactPerson}</span>
                  </div>
                </div>
                <div className="dropdown-footer">
                  <button onClick={handleLogout} className="logout-btn">
                    <span>🚪</span>
                    Logout
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="main-content-wrapper">
        {!selectedComponent ? (
          <div className='Dashboard-Part'>
            {/* Dashboard Header */}
            <div className="dashboard-hero">
              <div className="hero-content">
                <h1 className="hero-title">Vendor Dashboard</h1>
                <p className="hero-subtitle">
                  Manage your enquiries, responses, purchase orders, and bids in one place
                </p>
                {/* <div className="hero-stats">
                  <div className="stat-item">
                    <span className="stat-number">{counts.enquiry + counts.responded + counts.po + counts.bids}</span>
                    <span className="stat-label">Total Activities</span>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Dashboard Grid */}
            <div className="dashboard-grid-section">
              <h2 className="section-title">Quick Access</h2>
              <div className="dashboard-grid">
                {menuItems.map((item, index) => (
                  <div
                    key={index}
                    className="dashboard-card"
                    style={{ '--card-color': item.color }}
                  >
                    <div
                      className="card-header"
                      style={{ background: item.gradient }}
                    >
                      <div className="card-icon">
                        {item.icon}
                      </div>
                      <div className="card-count">{item.count}</div>
                    </div>
                    <div className="card-body">
                      <h3 className="card-title">{item.name}</h3>
                      <p className="card-description">
                        {item.name === "Enquiry" && "New purchase enquiries awaiting your response"}
                        {item.name === "Responded" && "Enquiries you have already responded to"}
                        {item.name === "PO" && "Purchase orders received from buyers"}
                        {item.name === "BIDS" && "Open bids available for participation"}
                      </p>
                    </div>
                    <div className="card-footer">
                      <button
                        className="card-action-btn"
                        onClick={() => handleNavigation(item.component)}
                      >
                        View Details
                        <span className="btn-arrow">→</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="selected-component-wrapper">
            {selectedComponent}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;